var React = require('react');

function MenuButton (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M4.92188 8.25C4.50767 8.25 4.17188 8.58578 4.17188 8.99999C4.17187 9.41421 4.50766 9.75 4.92187 9.75L19.0781 9.75011C19.4923 9.75012 19.8281 9.41433 19.8281 9.00012C19.8281 8.58591 19.4923 8.25012 19.0781 8.25011L4.92188 8.25ZM4.92188 14.25C4.50767 14.25 4.17188 14.5858 4.17188 15C4.17187 15.4142 4.50766 15.75 4.92187 15.75L19.0781 15.7501C19.4923 15.7501 19.8281 15.4143 19.8281 15.0001C19.8281 14.5859 19.4923 14.2501 19.0781 14.2501L4.92188 14.25Z","fill":"#121212"}));
}

MenuButton.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = MenuButton;

MenuButton.default = MenuButton;
